import { useAppSelector } from '../../app/hooks';
import TbhLogoWithText from '../../common/TbhLogoWithText';
import { ChooseCategory } from './components/ChooseCategory';
import { YearsInBusiness } from './components/YearsInBusiness';

const FormAfterSignUp = () => {
  const yearsInBusiness = useAppSelector((state) => state.formAfterSignUp.yearsInBusiness);
  return (
    <>
      <div className='flex justify-center'>
        <TbhLogoWithText />
      </div>
      {!yearsInBusiness ? <YearsInBusiness /> : <ChooseCategory />}
    </>
  );
};

export default FormAfterSignUp;
